export default "__VITE_ASSET__CevVVrFc__"